const ShareSvg = () => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 21 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_7968_43563)">
      <path
        d="M5.25 10V14.6666C5.25 14.976 5.37292 15.2728 5.59171 15.4916C5.8105 15.7104 6.10724 15.8333 6.41666 15.8333H13.4166C13.726 15.8333 14.0228 15.7104 14.2415 15.4916C14.4603 15.2728 14.5833 14.976 14.5833 14.6666V10"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.2501 6.49982L9.91681 4.1665L7.5835 6.49982"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.91663 4.1665V11.7498"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_7968_43563">
        <rect width="20" height="20" fill="white" transform="translate(0.25)" />
      </clipPath>
    </defs>
  </svg>
);

export default ShareSvg;
